import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["code", "acknowledge", "continue"];

  copy() {
    navigator.clipboard.writeText(this.text());
    this.markSaved();
  }

  download() {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(
      new Blob([this.text()], { type: "text/plain" })
    );
    link.download = "tourrise-recovery-codes.txt";
    link.click();
    URL.revokeObjectURL(link.href);
    this.markSaved();
  }

  // Copying or downloading counts as saving the codes, so it ticks the
  // acknowledgement; the checkbox stays available for codes written down by hand.
  markSaved() {
    this.acknowledgeTarget.checked = true;
    this.toggle();
  }

  toggle() {
    const enabled = this.acknowledgeTarget.checked;
    this.continueTarget.disabled = !enabled;
    this.continueTarget.setAttribute("aria-disabled", String(!enabled));
    this.continueTarget.tabIndex = enabled ? 0 : -1;
    this.continueTarget.classList.toggle("opacity-50", !enabled);
    this.continueTarget.classList.toggle("pointer-events-none", !enabled);
  }

  text() {
    return this.codeTargets.map((code) => code.textContent.trim()).join("\n");
  }
}
